import {
    useUpdateUserProfile
} from "../../features/profile/profileApi";
import React, { useEffect, useState } from "react";
import {ProfileModel, ProfileUpdateModel} from "../../features/profile/profileTypes";
import {useFormErrors} from "../../features/formErrors/formErrors";
import {useFetchCountries} from "../../features/country/countryApi";
import {useLoading} from "../../context/LoadingContext";
import toast from "react-hot-toast";

type Props = {
    profile: ProfileModel;
}

const ProfileEditContent = ({profile}: Props) => {
    const { data: countries } = useFetchCountries();
    const [ formData, setFormData] = useState<ProfileUpdateModel | null>(null);
    const { mutate: updateProfile } = useUpdateUserProfile();
    const { handleError, clearErrors, renderError } = useFormErrors();
    const { setLoading } = useLoading();

    useEffect(() => {
        setFormData({
            ...profile,
            country: profile.country.id,
            gender: profile.gender?.id ?? ''
        });
    }, [profile]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { id, value } = e.target;
        if (formData) {
            setFormData({ ...formData, [id]: value });
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        if (formData) {
            updateProfile({...formData}, {
                onError: (error) => {
                    toast.error('Error occured');
                    handleError(error);
                },
                onSuccess: () => {
                    toast.success('Profile saved');
                    clearErrors();
                },
                onSettled: () => {
                    setLoading(false);
                }
            });
        }
    };

    if (!formData || !countries) {
        return <></>;
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className='row anim-delay-medium'>
                <div className='col-md-6 mb-2 slide-right'>
                    <label className="form-label">First name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        value={formData.firstname ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("firstname")}
                </div>
                <div className='col-md-6 mb-2 slide-right'>
                    <label className="form-label">Last name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        value={formData.lastname ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("lastname")}
                </div>
                <div className='col-12 mb-2 slide-right'>
                    <label className="form-label">Username</label>
                    <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={formData.name ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("name")}
                </div>
                <div className="col-12 mb-2 slide-right">
                    <label className="form-label">Country</label>
                    <select
                        className="form-select"
                        id="country"
                        value={formData.country}
                        onChange={handleChange}
                    >
                        {countries.map((country) => (
                            <option key={country.id}
                                    value={country.id}>{country.name}</option>
                        ))}
                    </select>
                    {renderError("country")}
                </div>
                <div className="col-12 mb-2 slide-right">
                    <label className="form-label">City</label>
                    <input
                        type="text"
                        className="form-control"
                        id="city"
                        placeholder="Where are you from?"
                        value={formData.city ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("city")}
                </div>
                <div className="col-12 mb-2 slide-right">
                    <label className="form-label">Gender</label>
                    <select
                        className="form-select"
                        id="gender"
                        value={formData.gender}
                        onChange={handleChange}
                    >
                        <option value="">Choose your gender</option>
                        <option value="m">Male</option>
                        <option value="f">Female</option>
                        <option value="o">Other</option>
                    </select>
                    {renderError("gender")}
                </div>
                <div className="col-12 mb-2 slide-right">
                    <label className="form-label">Wheel</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="What kind of wheel are you using?"
                        id="wheel"
                        value={formData.wheel ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("wheel")}
                </div>
                <div className="col-12 mb-2 slide-right">
                    <label className="form-label">About</label>
                    <textarea
                        className="form-control"
                        id="about"
                        placeholder="Tell us more about your profile"
                        value={formData.about ?? ''}
                        onChange={handleChange}
                    />
                    {renderError("about")}
                </div>
                <div className='col-auto'>
                    <button type="submit" className="btn btn-primary">
                        Save Changes
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ProfileEditContent;
